const selectionTypeConstants = {
  ATOM: 'Atom',
  RESIDUE: 'Residue',
  CHAIN: 'Chain',
};

export default selectionTypeConstants;



// WEBPACK FOOTER //
// ./src/constants/selection_types_constants.js